module.exports = "/_next/static/images/2845f4ce118d876ac4c240aefd9418c5-opcoes_parcelas.png.webp";